import { render, staticRenderFns } from "./user-layout.vue?vue&type=template&id=e7215022&scoped=true"
import script from "./user-layout.vue?vue&type=script&lang=js"
export * from "./user-layout.vue?vue&type=script&lang=js"
import style0 from "./user-layout.vue?vue&type=style&index=0&id=e7215022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7215022",
  null
  
)

export default component.exports